import { GroupLocalStorage } from '@/entities/structure/group';
import { CompanyLocalStorage } from '@/entities/structure/company';
import { BranchLocalStorage } from '@/entities/structure/branch';
import { UserLocalStorage } from '@/entities/user';
import { VehicleLocalStorage } from '@/entities/vehicle';
import { VehicleCheckLocalStorage } from '@/entities/vehicle-check';
import { CheckPointLocalStorage } from '@/entities/checkpoint';
import { EquipmentLocalStorage } from '@/entities/equipment';
import { DamageLocalStorage } from '@/entities/damage';
import { VehicleCheckTypeLocalStorage } from '@/entities/vehicle-check-type';

export const clearLocalStorageFilters = () => {
  Object.values(GroupLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(CompanyLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(BranchLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(UserLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(VehicleLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(VehicleCheckLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(CheckPointLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(EquipmentLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(DamageLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });

  Object.values(VehicleCheckTypeLocalStorage).forEach((key) => {
    localStorage.removeItem(key);
  });
};
